import { z } from 'zod';

export const AddUserSchema = z.object({
  id: z.number().optional(),
  username: z.string().min(1, 'Username is required'),
  phoneNumber: z.string().min(1, 'Phone number is required'),
  email: z.string().email('Invalid email'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  role: z.string().min(1, 'Role is required'),
  address: z.string().min(1, 'Address is required'),
});

export type AddUserSchemaT = z.infer<typeof AddUserSchema>;
